import React, { Component } from 'react'
import Navbar from '../Components/NavBar'
import Blogs from '../Components/Blogs'
import Footer from '../Components/Footer'

export class BlogsPage extends Component {
  render() {
    return (
      <div>
        <Navbar/>
        <Blogs/>
        <Footer/>
      </div>
    )
  }
}

export default BlogsPage
